<p-select
  [options]="dataSource"
  [(ngModel)]="selectedItem"
  optionLabel="name"
  placeholder="Select Language"
  class="dropdown-select gap-2"
>
  <!-- Selected Item Template -->
  <ng-template pTemplate="selectedItem" let-selectedOption>
    @if(selectedItem){
    <div class="selected-option d-flex align-items-center gap-2">
    <img class="flag" [src]="selectedOption.flag" [alt]="'Country flag'" />
      <div>{{ selectedOption.name }}</div>
    </div>
    }
  </ng-template>

  <!-- Dropdown Options Template -->
  <ng-template pTemplate="item" let-option>
    <div class="dropdown-options d-flex align-items-center gap-2">
      <img class="flag" [src]="option.flag" [alt]="'Country flag'" />
      <div>{{ option.name }}</div>
    </div>
  </ng-template>
</p-select>
